<template>
  <transition name="vuemodal-fade">
    <div class="vuemodal-backdrop" @click.self="close">
      <div class="vuemodal"
        role="dialog"
        aria-labelledby="vuemodalTitle"
        aria-describedby="vuemodalDescription"
      >
        <header
          class="vuemodal-header"
          id="vuemodalTitle"
        >
         <!-- <slot name="header" v-if="showtitle">
            This is the default tile!
          </slot>
          -->
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            x
          </button>
        </header>

        <section
          class="vuemodal-body"
          id="vuemodalDescription"
        >
          <slot name="body">
            This is the default body!
          </slot>
        </section>

        <footer class="vuemodal-footer" >
          <button
            type="button"
            class="btn-green"
            @click="close"
            aria-label="Close modal"
          >
            {{closeMessage}}
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
     closeMessage: {
        type:String,
        required:false,
        default: 'Close me!'
      }
      
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style>
  .vuemodal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:1000;
  }

  .vuemodal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    position:fixed;
    flex-direction: column;
    width:clamp(400px, 700px, 85%);
    max-height:95%;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%);

  }

  .vuemodal-header,
  .vuemodal-footer {
    padding: 15px;
    display: flex;
  }

  .vuemodal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    background-color:#4AAE9B;
    color: #fff;
    justify-content: space-between;
    height: 50px;
        -webkit-box-shadow: 0 8px 6px -6px black;
      -moz-box-shadow: 0 8px 6px -6px black;
            box-shadow: 0 8px 6px 0px black;
  }

  .vuemodal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
  }

  .vuemodal-body {
    position: relative;
    padding: 0px;
    overflow-y:auto;
  }

  .btn-close {
    position: absolute;
    top: 10px;
    right: 20px;
    border: none;
    font-size: 25px;
    line-height:1.2;
    padding: 0px;
    cursor: pointer;
    font-weight: bold;
    color: #fff;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .vuemodal-fade-enter,
  .vuemodal-fade-leave-to {
    opacity: 0;
  }

  .vuemodal-fade-enter-active,
  .vuemodal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>